import { BanknotesIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { userSearchAvatar } from '../constants/Avatar';
import { Link, useNavigate } from 'react-router-dom';
import { Chip } from '@mui/material';
import { logBrazeEvent } from '../utils/brazeEvents';

const CandidateGridView = ({ candidateData, jobData }) => {
  const visibleChipsLimit = 3;

  const navigate = useNavigate();
  const getLocationString = (candidateData) => {
    if (!candidateData) return 'N/A';

    const location = candidateData.city || candidateData.geo_name;

    const state = candidateData.state || candidateData.geo_state;

    if (!location) return null;

    // Process the location string
    const processedLocation = location
      .replace(/^Greater\s+/, '') // Remove "Greater" only at the start
      .replace(/\s+Area$/, '') // Remove "Area" only at the end
      .trim();

    return `${processedLocation}${state ? `, ${state}` : ''}`;
  };

  const handleCandidateClick = (candidate) => {
    logBrazeEvent('viewed_candidate', {
      candidate_name: `${candidate.first_name} ${candidate.last_name}`,
      job_title: jobData.title,
    });
  };

  return (
    <div className="relative overflow-x-auto sm:rounded-lg">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {candidateData.map((user) => (
          <div
            key={user.id}
            className="relative py-10 px-8 bg-white text-center border border-gray-200 rounded-lg"
          >
            <div className="flex items-center justify-center">
              <div className="w-20 h-20 rounded-full overflow-hidden">
                {userSearchAvatar(user.photo, user.gender)}
              </div>
            </div>
            <Link
              to={`/admin/user/${user.user_id}`}
              target="_blank"
              className="text-lg font-medium mb-1"
              onClick={() => handleCandidateClick(user)}
            >{`${user.first_name || 'N/A'} ${user.last_name || 'N/A'}`}</Link>
            <div className="mb-3">
              <p className="text-sm text-[#1967d2]">
                {user.job_title || 'N/A'}
              </p>
            </div>
            <div className="flex justify-center mb-3 space-x-7">
              {/* location */}
              <div className="flex items-center space-x-2 text-gray-500">
                <MapPinIcon className="w-5 h-5 " aria-hidden="true" />
                <div>{getLocationString(user.geoLocation)}</div>
              </div>
              {/* salary */}
              <div className="flex items-center space-x-2 text-gray-500">
                <BanknotesIcon className="w-5 h-5" aria-hidden="true" />
                <div>
                  <p>{user.salary || 'N/A'}</p>
                </div>
              </div>
            </div>
            <div className="mt-2">
              {user.skills?.length > 0 ? (
                <>
                  {user.skills.slice(0, visibleChipsLimit).map((skill) => (
                    <Chip
                      key={skill.skill_id}
                      label={skill.skill_name}
                      variant="filled"
                      sx={{
                        mr: 0.5,
                        mt: 0.5,
                      }}
                    />
                  ))}
                  {user.skills.length > visibleChipsLimit && (
                    <Chip
                      key="more"
                      label={`+${user.skills.length - visibleChipsLimit}`}
                      variant="filled"
                      sx={{ mr: 0.5, mt: 0.5 }}
                    />
                  )}
                </>
              ) : null}
            </div>
            <div className="mt-4">
              <button
                className="bg-blue-100 text-blue-600 rounded-lg px-7 py-3 text-sm w-full hover:bg-blue-600 hover:text-white transition-colors duration-300 ease-in-out"
                onClick={() => {
                  handleCandidateClick(user);
                  navigate(`/admin/user/${user.user_id}`);
                }}
              >
                View Profile
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CandidateGridView;
